import { Link } from 'react-router-dom';

export default function AccessibilityPage() {
  return (
    <div className="min-h-screen pt-16 bg-white" data-testid="accessibility-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <h1 
          className="text-4xl font-black text-slate-900 mb-8"
          style={{ fontFamily: 'Chivo, sans-serif' }}
        >
          Accessibility Statement
        </h1>
        
        <p className="text-slate-600 mb-8">
          Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </p>

        <div className="prose prose-slate max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Our Commitment
            </h2>
            <p className="text-slate-600">
              MLC TECH is committed to ensuring digital accessibility for people with disabilities. 
              We are continually improving the user experience for everyone and applying the relevant 
              accessibility standards.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Conformance Status
            </h2>
            <p className="text-slate-600">
              We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. 
              These guidelines explain how to make web content more accessible for people with 
              disabilities and more user-friendly for everyone.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Accessibility Features
            </h2>
            <p className="text-slate-600 mb-4">
              Our website includes the following accessibility features:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2">
              <li>Keyboard navigation support throughout the site</li>
              <li>Clear headings and structure for screen readers</li>
              <li>Alternative text for images</li>
              <li>Sufficient color contrast ratios</li>
              <li>Resizable text without loss of functionality</li>
              <li>Focus indicators for interactive elements</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Known Limitations
            </h2>
            <p className="text-slate-600">
              While we strive for full accessibility, some areas of our website may have limitations. 
              We are actively working to identify and address these issues. If you encounter any 
              barriers, please contact us so we can assist you.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Feedback
            </h2>
            <p className="text-slate-600 mb-4">
              We welcome your feedback on the accessibility of our website. Please let us know if 
              you encounter accessibility barriers:
            </p>
            <ul className="list-none text-slate-600 space-y-2">
              <li><strong>Email:</strong>{' '}
                <a href="mailto:info@mlctech.org" className="text-blue-600 hover:text-blue-700">
                  info@mlctech.org
                </a>
              </li>
              <li><strong>Phone:</strong>{' '}
                <a href="tel:6026491314" className="text-blue-600 hover:text-blue-700">
                  (602) 649-1314
                </a>
              </li>
            </ul>
            <p className="text-slate-600 mt-4">
              We try to respond to accessibility feedback within 2 business days.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Alternative Access
            </h2>
            <p className="text-slate-600">
              If you are unable to access any content or functionality on our website, please contact 
              us directly and we will be happy to provide the information or service you need through 
              alternative means.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200">
          <Link to="/" className="text-blue-600 hover:text-blue-700 font-medium">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
